import { Injectable, OnDestroy } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService implements OnDestroy {
  private expiryTime = 60 * 60 * 1000; // 1 hour in milliseconds
  private interval: any;

  constructor() {
    this.checkExpiry();
    this.startExpiryCheck();
  }

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  private startExpiryCheck(): void {
    this.interval = setInterval(() => this.checkExpiry(), 60000); // Check every minute
  }

  private checkExpiry(): void {
    const currentTime = new Date().getTime();

    // Check Local Storage
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key?.endsWith('_expiry')) {
        const originalKey = key.replace('_expiry', '');
        const expiry = localStorage.getItem(key);
        if (expiry && currentTime > +expiry) {
          localStorage.removeItem(originalKey);
          localStorage.removeItem(key);
        }
      }
    }

    // Check Session Storage
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key?.endsWith('_expiry')) {
        const originalKey = key.replace('_expiry', '');
        const expiry = sessionStorage.getItem(key);
        if (expiry && currentTime > +expiry) {
          sessionStorage.removeItem(originalKey);
          sessionStorage.removeItem(key);
        }
      }
    }
  }

  // Session Storage Methods

  setSessionStorageItem(key: string, value: any): void {
    sessionStorage.setItem(key, JSON.stringify(value));
    sessionStorage.setItem(`${key}_expiry`, (new Date().getTime() + this.expiryTime).toString());
  }

  getSessionStorageItem(key: string): any {
    this.checkExpiry();
    const item = sessionStorage.getItem(key);
    return this.isValidJson(item) ? JSON.parse(item!) : item;
  }

  removeSessionStorageItem(key: string): void {
    sessionStorage.removeItem(key);
    sessionStorage.removeItem(`${key}_expiry`);
  }

  clearSessionStorage(): void {
    sessionStorage.clear();
  }
  resetSessionStorageExpiry(key: string): void {
    const currentValue = this.getSessionStorageItem(key);
    if (currentValue !== null) {
      sessionStorage.setItem(`${key}_expiry`, (new Date().getTime() + this.expiryTime).toString());
    }
  }

  // Local Storage Methods

  setLocalStorageItem(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
    localStorage.setItem(`${key}_expiry`, (new Date().getTime() + this.expiryTime).toString());
  }

  getLocalStorageItem(key: string): any {
    this.checkExpiry();
    const item = localStorage.getItem(key);
    return this.isValidJson(item) ? JSON.parse(item!) : item;
  }

  removeLocalStorageItem(key: string): void {
    localStorage.removeItem(key);
    localStorage.removeItem(`${key}_expiry`);
  }

  clearLocalStorage(): void {
    localStorage.clear();
  }

  resetLocalStorageExpiry(key: string): void {
    const currentValue = this.getLocalStorageItem(key);
    if (currentValue !== null) {
      localStorage.setItem(`${key}_expiry`, (new Date().getTime() + this.expiryTime).toString());
    }
  }

  // Helper method to validate JSON
  private isValidJson(item: string | null): boolean {
    if (item === null) {
      return false;
    }
    try {
      JSON.parse(item);
      return true;
    } catch (e) {
      return false;
    }
  }
}
